import { Award, Leaf, ShieldCheck, Gift } from "lucide-react";

const features = [
  { icon: Award, title: "Premium Quality", desc: "Finest ingredients for a long-lasting burn" },
  { icon: Leaf, title: "Handcrafted", desc: "Poured with love by skilled artisans" },
  { icon: ShieldCheck, title: "Safe & Natural", desc: "Non-toxic, eco-friendly, cruelty-free" },
  { icon: Gift, title: "Perfect Gift", desc: "Beautifully packed for your loved ones" },
];

export function Marquee() {
  return (
    <section className="bg-primary text-cream border-y border-white/5">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10 grid grid-cols-2 lg:grid-cols-4 gap-y-8 gap-x-4 sm:gap-x-6 py-10">
        {features.map(({ icon: Icon, title, desc }) => (
          <div key={title} className="flex items-start gap-3 sm:gap-4 min-w-0">
            <div className="h-10 w-10 sm:h-11 sm:w-11 rounded-full border border-gold/50 grid place-items-center shrink-0">
              <Icon className="h-5 w-5 text-gold" strokeWidth={1.4} />
            </div>
            <div className="min-w-0">
              <div className="text-[0.7rem] sm:text-sm uppercase tracking-[0.15em] sm:tracking-[0.2em] font-medium">{title}</div>
              <div className="text-[0.7rem] sm:text-xs text-cream/60 mt-1 leading-relaxed">{desc}</div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
